export default {
  isShown: (state) => state.isShown,
  editId: (state) => state.editId,
  parentSidebarItems: (state) => state.parentSidebarItems,
  menuList: (state) => state.menuList,
  isMenuEditable: (state) => state.isMenuEditable,
};
